export default "__VITE_ASSET__uECjuhcy__"